module.exports = __webpack_public_path__ + "static/media/FloodAnalysis_001.2467229a.png";